import './App.css';
import {Route, Routes, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {
  ADMIN_CALCULATE_PAGE,
  ADMIN_PANG_GIFT_HISTORY_PAGE,
  ADMIN_PANG_HISTORY_PAGE,
  ADMIN_REPORT_PAGE,
  ADMIN_REPORT_PAGE2,
  ADMIN_REQUEST_MANAGEMENT_PAGE,
  ADMIN_SEND_PANG_GIFT_PAGE,
  ALL_CUSTOMER_MANAGEMENT_PAGE,
  ALL_STORE_LIST_MANAGEMENT_PAGE,
  BANKER_GRANT_PERMISSIONS_PAGE,
  BANKER_PANG_GIFT_HISTORY_PAGE,
  BANKER_PANG_HISTORY_PAGE,
  BANKER_SEND_PANG_GIFT_PAGE,
  BOARD_DETAIL_PAGE,
  BOARD_LIST_PAGE,
  BOARD_WRITE_PAGE,
  DEVELOPER_MANAGEMENT_PAGE,
  DEVELOPER_MONITORING_PAGE,
  DEVELOPMENT_HISTORY_PAGE,
  EXCEL_LOAD_PAGE,
  FAQ_PAGE,
  FORBIDDEN_PAGE,
  GAME_MANAGEMENT_PAGE,
  GAME_ROUND_MANAGEMENT_PAGE,
  LOGIN_PAGE,
  MAIN_PAGE,
  MAIN_PAGE_TEMP,
  MANAGE_SUPPORT_PAGE,
  MONITORING_STORE_PAGE,
  MY_CART_PAGE,
  MY_INFO_PAGE,
  MY_PANG_GIFT_HISTORY_PAGE,
  MY_PANG_HISTORY_PAGE,
  MY_SEND_PANG_GIFT_PAGE,
  MY_SETTING_PAGE,
  MY_STORE_INFO_PAGE,
  MY_STORE_LIST_PAGE, NICE_AUTH_PAGE, NICE_CALLBACK_PAGE,
  REQUEST_LIST_PAGE,
  SIGNUP_PAGE,
  STAFF_MANAGEMENT_PAGE,
  STORE_CUSTOMER_MANAGEMENT_PAGE,
  STORE_MANAGEMENT_PAGE,
  STORE_PANG_GIFT_HISTORY_PAGE,
  STORE_PANG_HISTORY_PAGE,
  STORE_REPORT_PAGE,
  STORE_REQUEST_LIST_PAGE,
  STORE_SEND_PANG_GIFT_PAGE,
  TICKET_PRINT_PAGE,
  UNREGISTER_PAGE,
  WAIT_PAGE
} from "./constants/page_constants";
import SignUpPage from "./pages/SignUpPage";
import MainPage from "./pages/MainPage";
import MyInfoPage from "./pages/MyInfoPage";
import MyFavoriteStoreListPage from "./pages/MyFavoriteStoreListPage";
import FAQPage from "./pages/FAQPage";
import MyGameCartPage from "./pages/ticketListPage/MyGameCartPage";
import LoginPage from "./pages/LoginPage";
import RequestListPage from "./pages/ticketListPage/RequestListPage";
import MyStoreInfoPage from "./pages/storePage/MyStoreInfoPage";
import AllCustomerManagementPage from "./pages/adminPage/AllCustomerManagementPage";
import StaffManagementPage from "./pages/storePage/StaffManagementPage";
import {toast, ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import StoreRequestListPage from "./pages/ticketListPage/StoreRequestListPage";
import CustomerReportPage from "./pages/storePage/CustomerReportPage";
import React, {useEffect, useState} from "react";
import {SoundOption, SoundPlayer, SoundPlayerHandle} from "./utils/Soundplayer";
import BoardDetailPage from "./pages/board/BoardDetailPage";
import AllStoreListManagementPage from "./pages/adminPage/AllStoreListManagementPage";
import StoreManagementPage from "./pages/adminPage/StoreManagementPage";
import BoardWritePage from "./pages/board/BoardWritePage";
import BoardListPage from "./pages/board/BoardListPage";
import ExcelLoadPage from "./pages/ExcelLoadPage";
import StoreCustomerManagementPage from "./pages/storePage/StoreCustomerManagementPage";
import GameRoundManagementPage from "./pages/adminPage/GameRoundManagementPage";
import GameManagementPage from "./pages/adminPage/GameManagementPage";
import AdminRequestListPage from "./pages/ticketListPage/AdminRequestListPage";
import AdminReportPage from "./pages/adminPage/AdminReportPage";
import WindowInterfaces, {setStorePrintHandler} from "./pages/WindowInterfaces";
import {getRegisteredMenus} from "./constants/component_data";
import MySettingPage from "./pages/MySettingPage";
import UnregisterPage from "./pages/UnregisterPage";
import neverLandNotificationInterface from "./utils/NeverLandNotificationInterface";
import {accountInfo} from "./constants/constants";
import {updateMyInfo} from "./utils/NeverLandRestFULInterface";
import {customToast, NoticeModalContainer} from "./utils/customToast";
import {getFetcher} from "./utils/fetcher";
import {CHANGE_GAME_STATE_TO_PRINT_DONE_API} from "./constants/api_constants";
import AdminCalculatePage from "./pages/adminPage/AdminCalculatePage";
import DevelopmentHistoryPage from "./pages/adminPage/DevelopmentHistoryPage";
import DirectMessageContainer from "./components/DirectMessageContainer";
import neverLandUtils from "./utils/NeverLandUtils";
import DeveloperManagementPage from "./pages/developerPage/DeveloperManagementPage";
import DeveloperMonitoringPage from "./pages/developerPage/DeveloperMonitoringPage";
import ForbidPage from "./pages/ForbidPage";
import MonitoringStorePage from "./pages/adminPage/MonitoringStorePage";
import TicketPrintPage from "./pages/ticketListPage/TicketPrintPage";
import AppPrivatePage from "./pages/AppPrivatePage";
import WaitPage from "./pages/WaitPage";
import ManageSupportPage from "./pages/adminPage/ManageSupportPage";
import MyPangHistoryPage from "./pages/pang/MyPangHistoryPage";
import MyPangGiftHistoryPage from "./pages/pang/MyPangGiftHistoryPage";
import MySendPageGiftPage from "./pages/pang/MySendPageGiftPage";
import StorePangHistoryPage from "./pages/pang/StorePangHistoryPage";
import StorePangGiftHistoryPage from "./pages/pang/StorePangGiftHistoryPage";
import StoreSendPageGiftPage from "./pages/pang/StoreSendPageGiftPage";
import AdminSendPageGiftPage from "./pages/pang/AdminSendPageGiftPage";
import AdminPangGiftHistoryPage from "./pages/pang/AdminPangGiftHistoryPage";
import AdminPangHistoryPage from "./pages/pang/AdminPangHistoryPage";
import BankerPangGiftHistoryPage from "./pages/pang/BankerPangGiftHistoryPage";
import BankerPangHistoryPage from "./pages/pang/BankerPangHistoryPage";
import BankerSendPageGiftPage from "./pages/pang/BankerSendPageGiftPage";
import BankerGrantPermissionsPage from "./pages/banker/BankerGrantPermissionsPage";
import MainNoticeModal from "./components/Modal/MainNoticeModal";
import NiceCallbackPage from "./pages/NiceCallbackPage";
import NiceAuthPage from "./pages/NiceAuthPage";

function updateMenuSelections(path, navi) {
  // url 주소에 따른 사이드바, 헤더 현재 페이지 current 속성 true
  let menuList = getRegisteredMenus();
  path = path + "|";

  if (menuList && menuList.length > 0) {
    let prevMenuList = menuList.find((menu) => menu.current);
    let navigationMessage = null;
    menuList.forEach(menu => {
      let temp = menu.link;
      let param = menu.parameter;
      if (param) {
        temp += "/" + param;
      }
      temp = temp + "|";
      menu.current = temp.includes(path);
      if (menu.current) {
        if (menu.name.endsWith("!")) {
          navigationMessage = '현재 준비중인 기능입니다.';
          navi(-1);
        }
        if (menu.notifyKey) {
          neverLandNotificationInterface.commitNotifications(menu.notifyKey);
        }
      }
    });
    if (navigationMessage !== null) {
      toast.info('현재 준비중인 기능입니다.');
    }
  }
}

//TODO targeter,alarmTiming에 따라 구분해서 설정
function _getSoundVolume(targetLink,targeter,alarmTiming) {
  // 내 알람 설정
  if (SoundOption.all_mute === 'true')
    return 0;
  if (accountInfo.getUserConfig().isOn('on_mute', false))
    return 0;

  if (!accountInfo.getUserConfig().isOn('on_notification_all', true))
    return 0;

  let base_volume=accountInfo.getUserConfig().isOn("on_notification_all_volume", 3);
  let this_volume=100;

  let keyMapping = [
    ['on_store_confirm', 'user', 'approval_complete'],
    ['on_confirm_request', 'store', 'approval_request'],
    ['on_request_register', 'store', 'betting'],
    ['on_request_print', 'user', 'change'],
  ];

  for (let data of keyMapping) {
    if (targeter===data[1]&&alarmTiming===data[2]) {
      this_volume= accountInfo.getUserConfig().isOn(data[0]+"_volume", 3)*base_volume*100/(5*5);

      console.log('1volume-noti-alarm: ['+targeter+'/'+alarmTiming+']='+this_volume);

      return this_volume;
    }
  }

  console.log('2volume-noti-alarm: ['+targeter+'/'+alarmTiming+']='+this_volume);

  return this_volume;
}
function _checkSoundOption(targetLink,targeter,alarmTiming) {
  // 내 알람 설정
  if (SoundOption.all_mute === 'true')
    return false;
  if (accountInfo.getUserConfig().isOn('on_mute', false))
    return false;

  if (!accountInfo.getUserConfig().isOn('on_notification_all', true))
    return false;

  // let keyMapping = [
  //   ["order_list", "on_request_print"],
  //   ["response_confirm_of_my_store", "on_store_confirm"],
  //   ["order_list_for_store", "on_request_register"],
  //   ["request_confirm_for_store_owner", "on_confirm_request"],
  //   ["on_game_result", "on_game_result"]
  // ];
  //
  // for (let data of keyMapping) {
  //   if (targetLink.includes("notifyKey:" + data[0])) {
  //     return accountInfo.getUserConfig().isOn(data[1]+"_volume", 0);
  //   }
  // }
  // return true;

  let keyMapping = [
    ['on_store_confirm', 'user', 'approval_complete'],
    ['on_confirm_request', 'store', 'approval_request'],
    ['on_request_register', 'store', 'betting'],
    ['on_request_print', 'user', 'change'],
  ];

  for (let data of keyMapping) {
    if (targeter===data[1]&&alarmTiming===data[2]) {
      if (accountInfo.getUserConfig().isOn(data[0], false)) {
        console.log('1ok-noti-alarm: ['+targeter+'/'+alarmTiming+']');
        return true;
      }
      console.log('3ex-noti-alarm: ['+targeter+'/'+alarmTiming+']');
      return false;
    }
  }
  console.log('2ok-noti-alarm: ['+targeter+'/'+alarmTiming+']');
  return true;
}

// function sendDirectMessage(paramJson) {
//
// }

function App() {
  const [is_first_navigation, setIs_first_navigation] = useState(false);
  const navi = useNavigate();
  const soundPlayer = new SoundPlayerHandle();
  const path = useLocation().pathname;
  const [noticeModalOpen, setNoticeModalOpen] = useState(false);
  const [params] = useSearchParams();

  const [overText, setOverText] = useState({message: "testesttest", positionX: 100, positionY: 100});


  neverLandNotificationInterface.playSound = (alarmVolume) => soundPlayer.play("noti", "noti", alarmVolume);
  neverLandNotificationInterface.checkSoundOption = (targetLink,targeter,alarmTiming) => _checkSoundOption(targetLink,targeter,alarmTiming);
  neverLandNotificationInterface.getSoundVolume = (targetLink,targeter,alarmTiming) => _getSoundVolume(targetLink,targeter,alarmTiming);
  neverLandNotificationInterface.event.onRelogin = () => {
    updateMyInfo(navi)
  };

  neverLandNotificationInterface.event.onDisplayMessage = (message) => {
    toast.info(message, {position: "top-right"});
  };

  neverLandUtils.events.onCommonPopup = (message, e) => {
    //toast.info(message, { position: "top-right" });
    //toast(message+" - ["+e.clientX+"/"+e.clientY+"]");
    showToastAtClickPosition(message, e);
  };

  const showToastAtClickPosition = (message, e) => {
    // 클릭한 위치값 받아서 토스트 띄우기
    // setOverText({message:message, positionX:e.clientX, positionY:e.clientY});
    toast(message);
  };

  neverLandUtils.events.onLogout = (message) => {
    navi(MAIN_PAGE);
    toast.success(message);
  };

  // const [isAllowed, setIsAllowed] = useState(null);
  //
  // useEffect(() => {
  //   if (params) {
  //     console.log('params', params.get("accessCode"));
  //     if (params.get("accessCode") === '7741') {
  //       neverLandUtils.commons.save('isAllowed', true);
  //     }
  //   }
  //
  //   const savedPermission = neverLandUtils.commons.load('isAllowed');
  //   if (savedPermission === true) {
  //     setIsAllowed(true); // 로컬 스토리지에서 승인된 경우
  //     return;
  //   }
  //
  //   // 로컬 스토리지에 값이 없으면 IP 검사해서 승인되지 않은 IP 대기화면으로 이동
  //   fetch('https://api64.ipify.org?format=json') // IP 가져오기
  //       .then((response) => response.json())
  //       .then((data) => {
  //         const allowedIps = ['112.221.217.60', '175.200.232.235']; // 허용된 IP
  //         const isIpAllowed = allowedIps.includes(data.ip);
  //         setIsAllowed(isIpAllowed);
  //
  //         if (isIpAllowed) {
  //           neverLandUtils.commons.save('isAllowed', true);
  //         } else {
  //
  //           const SET_SYSTEM_LOG_API = '/system/log/set/system_log'
  //
  //           getFetcherEB().post(SET_SYSTEM_LOG_API, {
  //             logDeviceName: navigator.userAgent === null ? "" : navigator.userAgent,
  //             logLevelEnum: "WARNING",
  //             logIpAddress: convertIPv6ToIPv4(data.ip), // IPv4 변환 처리
  //             logClassName: process.env.REACT_APP_SERVICE_CODE,
  //             logMethodName: "",
  //             logAccountName: "",
  //             logDescription: "허가되지 않은 아이피로 접근하였습니다."
  //           }).then((res) => {
  //             if (res.data.responseIsSuccess) {
  //               console.error("성공");
  //             }
  //           }).catch(err => console.error(err.message));
  //         }
  //       })
  //       .catch((error) => {
  //         console.error('IP 확인 실패:', error);
  //         setIsAllowed(false); // 실패 시 WaitPage로 이동
  //       });
  // }, []);

  // IPv6 → IPv4 변환 함수
  function convertIPv6ToIPv4(ip) {
    if (ip.includes(':') && ip.startsWith('::ffff:')) {
      return ip.split(':').pop(); // IPv6에서 IPv4 부분만 추출
    }
    return ip; // 이미 IPv4라면 그대로 반환
  }

  // useEffect(() => {
  //   // 허용된 IP가 아닐 경우 WAIT_PAGE로 이동
  //   if (isAllowed === false) {
  //     if (path !== WAIT_PAGE) {
  //       setTimeout(() => {
  //         navi(WAIT_PAGE);
  //       }, 10);
  //     }
  //   }
  // }, [isAllowed, path]);

  setStorePrintHandler((param, refresh) => {
    if (param.includes('printing') && param.includes('done')) {

      let plist = param.split('&');
      let ticket = null;
      for (let temp of plist) {
        if (temp.includes("idList=")) {
          ticket = temp.split("=")[1].replaceAll("'", "").split("▼");
        }
      }

      if (ticket !== null) {
        // 지점에서 처리상태 변경 (인쇄완료)
        getFetcher().post(CHANGE_GAME_STATE_TO_PRINT_DONE_API, {
          user: accountInfo.makeJson(),
          gameDataIdList: ticket,
        }).then((res) => {
          const header = res.data.header;
          if (header.type === "success") {
            customToast.success("request", "출력 처리", header.message);
            if (refresh) {
              refresh();
            }
          } else {
            toast.error("변경이 실패하였습니다.");
          }
        }).catch(err => toast.error(err.message));
      }
    }
  })

  const notiDataToLocal = neverLandUtils.commons.load('noti_modal');
  const checkShowNoticeModal = () => {
    const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD 형식으로 반환
    // 로그인 안했으면 공지 모달 안보이게
    // if (!accountInfo.isLogin()) {
    //   setNoticeModalOpen(false);
    //   return
    // }

    // 로컬에 isOpen:false -> 팝업 안띄우기
    // lastShownDate(팝업 닫은 날짜)가 오늘이 아니면 isOpen:true 변경해서 보이기
    if (!notiDataToLocal.lastShownDate || notiDataToLocal.lastShownDate !== today) {
      setNoticeModalOpen(true);
      const updatedData = {
        ...notiDataToLocal,
        isOpen: true
      };
      try {
        neverLandUtils.commons.save('noti_modal', updatedData);
      } catch (e) {
        console.error('Error saving to localStorage:', e);
      }
    }
    if (neverLandUtils.commons.load('noti_modal').isOpen === false) {
      setNoticeModalOpen(false);
    }
    return false;
  }

  // 점검 후 정상화되면 isSeverModification = false 해야됨
  const isSeverModification = false;

  useEffect(() => {
    if (isSeverModification) {
      return;
    }
    // 로컬 스토리지에서 알림창 데이터 불러오기
    // 로컬 스토리지에서 알림창 데이터 없으면 저장
    if (notiDataToLocal === null) {
      neverLandUtils.commons.save('noti_modal', {isOpen: true});
      setNoticeModalOpen(true);
    } else {
      // 있으면 체크해서 띄울지 정하기
      checkShowNoticeModal();
    }
  }, []);

  function navigateLastPage() {
    // 마지막 페이지 위치로 이동
    if (path === MAIN_PAGE) {
      if (accountInfo.isLogin()) {
        if (!is_first_navigation) {
          let lastPath = accountInfo.loadLastNavigation();
          accountInfo.saveLastNavigation(null);
          if (lastPath !== null || lastPath !== path) {
            setIs_first_navigation(true);
            if (lastPath !== null && (
                lastPath.includes('resources/')
                || lastPath.includes('.img')
                || lastPath.includes('.png')
                || lastPath.includes('.gif')
                || lastPath.includes('.exe')
                || lastPath.includes('/install')
            )) {
              return;
            }
            navi(lastPath);
            return;
          }
        }
        setIs_first_navigation(true);
      }
    }
  }

  useEffect(() => {
    if (isSeverModification) {
      return;
    }

    neverLandNotificationInterface.start();
    navigateLastPage();

    return () => {
      neverLandNotificationInterface.destroy();
    };
  }, []);

  // 점검중일때 점검중 페이지 띄우기
  if (isSeverModification) {
    if (path !== FORBIDDEN_PAGE)
      setTimeout(() => {
        navi(FORBIDDEN_PAGE);
      }, 10)
  } else {
    updateMenuSelections(path, navi);
    // 로그인한 상태일때 마지막 페이지 위치 저장
    if (accountInfo.isLogin() && path !== LOGIN_PAGE && !path.includes(TICKET_PRINT_PAGE)) {
      if (!is_first_navigation) {
        if (path !== MAIN_PAGE) {
          accountInfo.saveLastNavigation(path);
        }
      } else {
        accountInfo.saveLastNavigation(path);
      }
    }
  }


  return (
      <>
        {noticeModalOpen && <MainNoticeModal setShowAddModal={setNoticeModalOpen}/>}
        <WindowInterfaces/>
        <Routes>
          {/*{(isAllowed === null || isAllowed === false) ? (*/}
          {/*    <>*/}
          {/*      <Route path={WAIT_PAGE} element={<WaitPage/>}/>*/}
          {/*    </>*/}
          {/*) : (*/}
          <>
            {/* <-- 공통 페이지 --> */}
            <Route path={LOGIN_PAGE} element={<LoginPage/>}/>
            <Route path={SIGNUP_PAGE} element={<SignUpPage/>}/>

            {/*나이스 인증 페이지*/}
            <Route path={NICE_CALLBACK_PAGE} element={<NiceCallbackPage/>}/>
            <Route path={NICE_AUTH_PAGE} element={<NiceAuthPage />} />

            <Route path={UNREGISTER_PAGE} element={<UnregisterPage/>}/>
            <Route path={MAIN_PAGE} element={<MainPage/>}/>
            <Route path={MAIN_PAGE_TEMP} element={<MainPage/>}/>
            <Route path={MY_CART_PAGE} element={<MyGameCartPage/>}/>
            <Route path={REQUEST_LIST_PAGE} element={<RequestListPage/>}/>
            <Route path={MY_INFO_PAGE} element={<MyInfoPage/>}/>
            <Route path={MY_STORE_LIST_PAGE} element={<MyFavoriteStoreListPage/>}/>
            <Route path={MY_SETTING_PAGE} element={<MySettingPage/>}/>

            <Route path={WAIT_PAGE} element={<WaitPage/>}/>

            {/* <-- 지점 페이지 --> */}
            <Route path={STORE_REQUEST_LIST_PAGE} element={<StoreRequestListPage/>}/>
            <Route path={MY_STORE_INFO_PAGE} element={<MyStoreInfoPage/>}/>
            <Route path={STAFF_MANAGEMENT_PAGE} element={<StaffManagementPage/>}/>
            <Route path={STORE_CUSTOMER_MANAGEMENT_PAGE} element={<StoreCustomerManagementPage/>}/>
            <Route path={STORE_REPORT_PAGE} element={<CustomerReportPage/>}/>

            {/* <-- 관리자 페이지 --> */}
            <Route path={MANAGE_SUPPORT_PAGE} element={<ManageSupportPage/>}/>
            <Route path={ALL_STORE_LIST_MANAGEMENT_PAGE} element={<AllStoreListManagementPage/>}/>
            <Route path={`${STORE_MANAGEMENT_PAGE}/:paramStoreCode?`} element={<StoreManagementPage/>}/>
            <Route path={ALL_CUSTOMER_MANAGEMENT_PAGE} element={<AllCustomerManagementPage/>}/>
            <Route path={GAME_ROUND_MANAGEMENT_PAGE} element={<GameRoundManagementPage/>}/>
            <Route path={GAME_MANAGEMENT_PAGE} element={<GameManagementPage/>}/>
            <Route path={ADMIN_REQUEST_MANAGEMENT_PAGE} element={<AdminRequestListPage/>}/>
            <Route path={ADMIN_REPORT_PAGE} element={<AdminReportPage/>}/>
            <Route path={ADMIN_REPORT_PAGE2} element={<AdminReportPage/>}/>
            <Route path={DEVELOPMENT_HISTORY_PAGE}
                   element={<DevelopmentHistoryPage setNoticeModalOpen={setNoticeModalOpen}/>}/>
            <Route path={ADMIN_CALCULATE_PAGE} element={<AdminCalculatePage/>}/>
            <Route path={MONITORING_STORE_PAGE} element={<MonitoringStorePage/>}/>

            {/* <-- 개발자 페이지 --> */}
            <Route path={DEVELOPER_MANAGEMENT_PAGE} element={<DeveloperManagementPage/>}/>
            <Route path={DEVELOPER_MONITORING_PAGE} element={<DeveloperMonitoringPage/>}/>

            {/* <-- 뱅커 페이지 --> */}
            <Route path={BANKER_GRANT_PERMISSIONS_PAGE} element={<BankerGrantPermissionsPage/>}/>

            {/* <-- 팡 ~~~ 페이지 --> */}
            <Route path={MY_PANG_HISTORY_PAGE} element={<MyPangHistoryPage/>}/>
            <Route path={MY_PANG_GIFT_HISTORY_PAGE} element={<MyPangGiftHistoryPage/>}/>
            <Route path={MY_SEND_PANG_GIFT_PAGE} element={<MySendPageGiftPage/>}/>

            <Route path={STORE_PANG_HISTORY_PAGE} element={<StorePangHistoryPage/>}/>
            <Route path={STORE_PANG_GIFT_HISTORY_PAGE} element={<StorePangGiftHistoryPage/>}/>
            <Route path={STORE_SEND_PANG_GIFT_PAGE} element={<StoreSendPageGiftPage/>}/>

            <Route path={ADMIN_PANG_HISTORY_PAGE} element={<AdminPangHistoryPage/>}/>
            <Route path={ADMIN_PANG_GIFT_HISTORY_PAGE} element={<AdminPangGiftHistoryPage/>}/>
            <Route path={ADMIN_SEND_PANG_GIFT_PAGE} element={<AdminSendPageGiftPage/>}/>

            <Route path={BANKER_PANG_HISTORY_PAGE} element={<BankerPangHistoryPage/>}/>
            <Route path={BANKER_PANG_GIFT_HISTORY_PAGE} element={<BankerPangGiftHistoryPage/>}/>
            <Route path={BANKER_SEND_PANG_GIFT_PAGE} element={<BankerSendPageGiftPage/>}/>


            {/* <-- 게시판 --> */}
            <Route path={`${BOARD_LIST_PAGE}/:cateId`} element={<BoardListPage/>}/>
            <Route path={FAQ_PAGE} element={<FAQPage/>}/>
            <Route path={BOARD_WRITE_PAGE} element={<BoardWritePage/>}/>
            <Route path={`${BOARD_DETAIL_PAGE}/:boardId`} element={<BoardDetailPage/>}/>

            {/*접근제한 페이지*/}
            <Route path={FORBIDDEN_PAGE} element={<ForbidPage/>}/>
            {/*엑셀 읽어오는 페이지*/}
            <Route path={EXCEL_LOAD_PAGE} element={<ExcelLoadPage/>}/>
            {/*모아찍기 페이지*/}
            <Route path={TICKET_PRINT_PAGE + "/:requestNumber"} element={<TicketPrintPage/>}/>

            <Route path={"/private"} element={<AppPrivatePage/>}/>
          </>
          {/*)}*/}
        </Routes>

        {/*/!* 페이지 이동시 스크롤 최상단으로 유지 *!/*/}
        {/* 사이드바안에 스크롤 버튼으로 대체 */}
        {/*<ScrollToTop/>*/}

        {/* 시스템 소리 */}
        <SoundPlayer initPlayerHandle={soundPlayer}/>

        {/* NoticeModalContainer(customToast) 알림 */}
        <NoticeModalContainer/>

        {/*{overText && overText.message && (*/}
        {/*    <div className="relative h-1 w-1">*/}
        {/*      <div*/}
        {/*          style={{*/}
        {/*            zIndex:60,*/}
        {/*            position: "absolute",*/}
        {/*            top: `${overText.positionY-document.documentElement.scrollHeight}px`,*/}
        {/*            left: `${overText.positionX}px`,*/}
        {/*            transform: "translate(-50%, -50%)", // 클릭 위치에서 중앙 정렬*/}
        {/*            backgroundColor: "white",*/}
        {/*            color: "black",*/}
        {/*            padding: "10px 20px",*/}
        {/*            borderRadius: "8px",*/}
        {/*            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",*/}
        {/*          }}*/}
        {/*      >*/}
        {/*        {overText.message}*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*)}*/}

        {/* 토스트 알림 */}
        <ToastContainer
            onOpen={() => soundPlayer.play("toast/" + path, "toast")}
            position="top-center"
            autoClose={1500}
            hideProgressBar={false}
            newestOnTop={false} // 새로운 알람 위치 - false : 아래쪽
            closeOnClick  // 클릭으로 알람 off
            rtl={false} // 알람 좌우 반전 X
            pauseOnFocusLoss={false} // 화면을 벗어나면 알람 정지 X
            draggable
            pauseOnHover={false} // 마우스 호버 시 일시정지 X
            theme="colored"
        />

        {/* 받은 쪽지함 */}
        <DirectMessageContainer onNewMessageReceived={() => soundPlayer.play("message/" + path, 'confirm')}/>
      </>
  );
}

export default App;
